<template>
    <v-card flat>
        <v-overlay :value="loadingClientData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" flat>
            <div class="toolbar-titles">
                <v-toolbar-title>{{ $route.params.clientId === "new" ? "Add new" : activeClient.name | t }}</v-toolbar-title>
                <div class="toolbar-subtitle" v-if="activeClient.shop_name">{{ activeClient.shop_name }}</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <div>
            <client-info-edit-tab />
            <v-divider class="my-2 mx-5" />
            <div class="section-header">{{ "Codes" | t }}</div>
            <client-codes-edit-tab />
        </div>
    </v-card>
</template>

<script>
import ClientInfoEditTab from "@/pages/clients/clients-tab-items/client-info-edit-tab";
import Store from "@/store";
import { mapActions, mapState } from "vuex";
import ClientCodesEditTab from "@/pages/clients/clients-tab-items/client-codes-edit-tab";

export default {
    name: "client-edit",
    components: { ClientCodesEditTab, ClientInfoEditTab },
    data() {
        return {};
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.clientId === "new") {
            Store.commit("ClientStore/addNewClient");
        } else {
            Store.dispatch("ClientStore/getClientData", this.$route.params.clientId);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ClientStore", ["activeClient", "loadingClientData", "errorMessage", "requestSuccess"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true && this.activeClient && this.activeClient.id) {
                // Refetch client data to get updated values
                Store.dispatch("ClientStore/getClientData", this.activeClient.id);
                this.$router.push({
                    name: "client-view",
                    params: { clientId: this.activeClient.id }
                });
            }
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        closeDrawer() {
            Store.commit("ClientStore/setInfoPanelOpen", false);
            this.$router.push({ name: "client-list" });
        },
        submitEdit() {
            Store.dispatch("ClientStore/submitClientUpdate", this.activeClient);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
        }
    }
};
</script>

<style scoped>
.toolbar-titles {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.toolbar-subtitle {
    font-size: 12px;
    color: #666;
    font-weight: normal;
}

.section-header {
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
    padding-left: 20px;
    color: #666;
}
</style>
